import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';

export default function ProductOrderListByStockoutProduct({ stockoutproductid }) {
    const [productOrderList, setProductOrderList] = useState([]);
    const { stockoutproducttoproductorderList } = useSelector((state) => state.manufslice);
    useEffect(() => {
        if (stockoutproducttoproductorderList && stockoutproducttoproductorderList.length > 0) {
            const filteredOrders = stockoutproducttoproductorderList.filter(order => order.stockoutproductid === stockoutproductid);
            setProductOrderList(filteredOrders);
        }
    }, [stockoutproducttoproductorderList]);
    return (
    <>
    {productOrderList.map((order, index) => (
      <Grid
        container
        direction="row"
        sx={{
          borderBottom: index !== productOrderList.length - 1 ? '1px solid #c4c4c4' : 'none',
          padding: 1,
          //backgroundColor: 'secondary.100',
          justifyContent: "flex-start",
          alignItems: "center",
          width: '100%'
        }}
        key={index}
      >
         <Grid item lg={2} xs={2} sx={{ width: '100%' }}>
          {order.orderid}
        </Grid>
        <Grid item lg={8} xs={8} sx={{ width: '100%' }}>
          {order.title}
        </Grid>
        <Grid item lg={2} xs={2} sx={{ width: '100%', paddingLeft: {lg:2,xs:0} }}>
          {order.qty}
        </Grid>
      </Grid>
    ))}
    </>
  )
}